/**
 * Minimal browser-console logger. Centralised so production code doesn't
 * scatter `console.log` calls and so we can redirect output later (e.g. to
 * a telemetry hook) without touching call sites.
 */
/* eslint-disable no-console -- this module is the sanctioned logger sink */
type LogArgs = readonly unknown[];

function emit(level: 'debug' | 'info' | 'warn' | 'error', args: LogArgs): void {
  // Intentional console usage — this is the sanctioned logger sink.
  const fn =
    level === 'error'
      ? console.error
      : level === 'warn'
        ? console.warn
        : level === 'info'
          ? console.info
          : console.debug;
  fn.apply(console, ['[ct-agent]', ...args]);
}

export const logger = {
  debug(...args: LogArgs): void {
    emit('debug', args);
  },
  info(...args: LogArgs): void {
    emit('info', args);
  },
  warn(...args: LogArgs): void {
    emit('warn', args);
  },
  error(...args: LogArgs): void {
    emit('error', args);
  },
};
